export default "__VITE_ASSET__C7gfNqV5__"